export default __webpack_public_path__ + "static/media/waves-reverse.796b6ec6.svg";